import React, { Fragment, useEffect, useState } from 'react';
import { SvgIcon } from 'core/icons';
import { useTranslate } from '../../../core/translate';

const CarouselButton = ({ prev, analyticsKey, onClick }) => {
  const [isHovered, setIsHovered] = useState(null);
  const className = `carousel-paddle ${
    prev
      ? 'carousel-paddle--left stat-arrow-prev'
      : 'carousel-paddle--right stat-arrow-next'
  }`;
  const ref = React.createRef();
  const translate = useTranslate();

  useEffect(() => {
    ref.current.addEventListener('click', onClick);
    ref.current.addEventListener('mouseenter', () => setIsHovered(true));
    ref.current.addEventListener('mouseleave', () => setIsHovered(false));
    ref.current.addEventListener('touchstart', () => setIsHovered(true));
    ref.current.addEventListener('touchend', () => setIsHovered(false));

    return () => {
      if (ref.current) {
        ref.current.removeEventListener('click', onClick);
        ref.current.removeEventListener('mouseenter', () => setIsHovered(true));
        ref.current.removeEventListener('mouseleave', () =>
          setIsHovered(false)
        );
        ref.current.removeEventListener('touchstart', () => setIsHovered(true));
        ref.current.removeEventListener('touchend', () => setIsHovered(false));
      }
    };
  }, []);

  return (
    <button
      className={className}
      data-dtm={analyticsKey}
      ref={ref}
      aria-label={
        prev
          ? translate('byo.page.general.prev.step')
          : translate('byo.page.general.next.step.v3')
      }>
      <SvgIcon
        name={`gallery-arrow-left${isHovered ? '-hover' : ''}`}
        className="carousel-paddle__arrow"
        aria-hidden="true"
      />
    </button>
  );
};

const MoreViewsCarouselButtons = ({
  isVisible,
  isZoomed,
  analyticsKey,
  onPrev,
  onNext,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Fragment>
      <CarouselButton
        prev
        analyticsKey={analyticsKey}
        onClick={onPrev}
        isZoomed={isZoomed}
      />
      <CarouselButton
        analyticsKey={analyticsKey}
        onClick={onNext}
        isZoomed={isZoomed}
      />
    </Fragment>
  );
};

export default MoreViewsCarouselButtons;
